import React from "react";

import { SettingsIconButton } from "../../../../components/button/SettingsIconButton";
import { SettingsDropdown } from "../../../../components/dropdown/SettingsDropdown";
import { Button } from "../../../../components/newUI/button";
import { ArrowSvg } from "../../../../components/svg/ArrowSvg";
import { DeactivateSvg } from "../../../../components/svg/DeactivateSvg";
import { DotsSvg } from "../../../../components/svg/DotsSvg";
import { TrashSvg } from "../../../../components/svg/TrashSvg";
import { WorkTypeEditorHeaderProps } from "../model/workTypeEditor.types";

export const WorkTypeEditorHeader: React.FC<WorkTypeEditorHeaderProps> = ({
  title,
  isEditing,
  isSaving,
  canShowActions,
  isActive,
  onBack,
  onCancel,
  onSave,
  onToggleActive,
  onDelete,
}) => (
  <div
    className={
      "mb-4 flex items-center justify-between border-b border-[#E4E9F2] py-3"
    }>
    <div className={"flex items-center gap-4"}>
      <SettingsIconButton
        onClick={onBack}
        icon={<ArrowSvg position={"left"} />}
      />
      <div className={"text-2xl font-semibold text-[#2B333C]"}>{title}</div>
    </div>
    <div className={"flex items-center gap-3"}>
      {canShowActions && (
        <SettingsDropdown
          actionsList={[
            {
              name: isActive ? "Deactivate" : "Activate",
              action: onToggleActive,
              icon: <DeactivateSvg />,
            },
            {
              name: "Delete",
              action: onDelete,
              icon: <TrashSvg />,
              extraClasses: "text-[#DC2626]",
              iconColor: "text-[#DC2626]",
            },
          ]}>
          <SettingsIconButton icon={<DotsSvg />} onClick={() => null} />
        </SettingsDropdown>
      )}
      <Button
        type={"button"}
        variant={"outline"}
        autoWidth
        onClick={onCancel}
        className={
          "border-[#C8D2DE] px-4 text-[#253747] hover:border-[#C8D2DE] hover:bg-white hover:shadow-settings-grey"
        }>
        Cancel
      </Button>
      <Button
        type={"button"}
        autoWidth
        disabled={isSaving}
        onClick={onSave}
        className={
          "border-[#6938EF] bg-[#6938EF] px-4 text-white hover:border-[#6938EF] hover:bg-[#6938EF] hover:shadow-settings-purple disabled:border-[#BDB4FE] disabled:bg-[#BDB4FE]"
        }>
        {isEditing ? "Save Changes" : "Add Work Type"}
      </Button>
    </div>
  </div>
);
